<div [innerHTML]="html"></div>
<ng-container *ngIf="blocksConfig.editable && !html">
  <div class="border p-2">
    Empty HTML Block.
  </div>
</ng-container>
